export default __webpack_public_path__ + "static/media/Macbook.41407d74.svg";